const userAgent = window.navigator.userAgent.toLowerCase();

if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
  // IEは何もしない
} else {
  const basicScroll = require('basicscroll');

  document.querySelectorAll('.js-bg').forEach(elem => {
    basicScroll
      .create({
        elem: elem,
        from: 'top-bottom',
        to: 'bottom-top',
        direct: true,
        props: {
          '--bgY': {
            // from: '',
            // to: '-250px'
            from: '50px',
            to: '-200px'
          }
        }
      })
      .start();
  });
}
